import $ from 'jquery';

var news_year = [];
var news_all = [];
var hash="";
var newsId = "";
export default class News {
  constructor(app) {
    this.app = app;
    this.init();
  }
  init(){
    this.getData();
  }
  getData(){
    var news_arr;
    var news_xhr = new XMLHttpRequest();
    news_xhr.open('get', this.app.host + 'api/news', true);
    news_xhr.send();
    news_xhr.onload = function() {
      if (news_xhr.status == 200) {
        news_arr = JSON.parse(news_xhr.responseText);
        // console.log(news_arr);
        var obj = news_arr.data;
        for(var x in obj){
          // console.log(x);
          // set year link
          for(var i=0 ; i< obj[x].length;i++){
            if ($.inArray(x, news_year) == -1) {
              news_year.push(x);
            }
            news_all.push(obj[x][i]);
          }

          // for (var i = 0; i < obj[x].length; i++) {
          //   var imgD = "";
          //   // console.log(imgD);
          //   for(var k=0;k< obj[x][i].medias.length;k++){
          //     imgD += '<img class="img__slider__img" src="'+this.app.host+obj[x][i].medias[k].path+'" alt="" />';
          //   }
          //   // console.log(imgD);
          //   $('.page__content').append(''+
          //     '<div class="row news__item" data-year="'+x+'">'+
          //     '<div class="col-12 col-lg-6">'+
          //       '<div class="news__imgBox">'+
          //         '<div class="img__slider">'+
          //           imgD+
          //         '</div>'+
          //       '</div>'+
          //     '</div>'+
          //     '<div class="col-12 col-lg-6 news__info">'+
          //       '<h3 class="title">'+obj[x][i].title+'</h3>'+
          //       '<h5 class="subtitle">'+obj[x][i].publish_date+'</h5>'+
          //       '<div>'+obj[x][i].content_desc+'</div>'+
          //     '</div>'+
          //     '</div>'
          //   )
          //
          // }
        }

      // this.setSlider();
      // this.hashchange();
      this.sortArr();
      }
    }.bind(this)
  }
  sortArr(){
    news_year.sort(function(a, b) {
      return b - a;
    })
    news_all.sort(function(a, b) {
      return new Date(b.publish_date) - new Date(a.publish_date);
    })
    this.buildPage();
  }
  buildPage() {
    this.buildCal();
    this.buildContent();
    this.gotoContent();
  }
  gotoContent(){
    if(this.app.prodId !== ""){
      this.showDetail();
    }
  }
  showDetail(){
    var mTitle;
    var mPics;
    var mDate;
    var mDes;

    for(var i=0;i<news_all.length;i++){
        if(news_all[i].id == this.app.prodId){
          mTitle = news_all[i].title;
          mPics = news_all[i].medias;
          var imgSlider = "";
          for(var p = 0 ; p< mPics.length;p++){
              imgSlider += '<img class="img__slider__img" src="' + this.app.host + news_all[i].medias[p].path + '" alt=""/>'
          }
          mDate = news_all[i].publish_date;
          mDes = news_all[i].content_desc;
        }
    }
    $('#newsModal').on('hidden.bs.modal', function (e) {
      var newAddr = window.location.href.replace('id='+newsId, '');
      window.location.replace(newAddr);
    })
    $('.modal-body .img__slider').html(imgSlider);
    $('#newsModal').modal('show');
    $('.modal-body .item__title').html(mTitle);
    $('.modal-body .item__date').html(mDate);
    $('.modal-body .item__text').html(mDes);
    if(mPics.length > 1){
       $('.modal-body .img__slider').slick('setPosition');
    }
    //
  }
  buildContent(){
    for(var i=0;i<news_all.length;i++){
        var imgD = "";
        // console.log(imgD);
        for(var k=0;k< news_all[i].medias.length;k++){
          imgD += '<img class="img__slider__img" src="'+this.app.host+news_all[i].medias[k].path+'" alt="" />';
        }
        // console.log(imgD);
        var x = news_all[i].publish_date.split('/')[0];
        $('.page__content').append(''+
          '<a class="row news__item" data-year="'+x+'" href="#sub'+x+'?id='+news_all[i].id+'">'+
          '<div class="col-12 col-lg-6">'+
            '<div class="news__imgBox">'+
              '<div class="img__slider">'+
                imgD+
              '</div>'+
            '</div>'+
          '</div>'+
          '<div class="col-12 col-lg-6 news__info">'+
            '<h3 class="title">'+news_all[i].title+'</h3>'+
            '<h5 class="subtitle">'+news_all[i].publish_date+'</h5>'+
            '<div>'+news_all[i].short_desc+'</div>'+
          '</div>'+
          '</a>'
        )
    }
  }
  buildCal(){
    for(var i=0 ;i <news_year.length;i++){
      $('.cal-slider').append(''+
        '<a class="hashlink__item__link" href="#sub'+news_year[i]+'">'+
         '<div class="hashlink__item">'+
          '<h2 class="text-center">'+news_year[i]+'</h2>'+
          '</div>'+
        '</a>'
      )
    }
    this.setCalSlider();
  }
  setCalSlider(){
    $('.cal-slider').slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      touchMove: false,
      mobileFirst: false,
      arrows: true,
      autoplay: false,
      responsive: [{
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 567,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
      ]
    })
  }
  setSlider() {
    $('.img__slider').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: false,
      nextArrow: false,
      dots: true
    })
  }
  refreshSlder() {
    $('.img__slider').slick('setPosition');
    $('.cal-slider').slick('setPosition');
    // this.setListener();
  }
  hashchange() {
    //
    hash = this.app.hash;
    if(this.app.hash==""){
      this.app.hash=$('.hashlink__item__link').last().attr('href').replace("#","");
    }
    else{

    }

    $('.hashlink__item__link[href="#'+this.app.hash+'"]').children('.hashlink__item').addClass('is-active');
    // console.log('this.app:',this.app.hash)
    var year = this.app.hash.replace("sub","");
    $('.news__item').hide();
    $('.news__item[data-year='+year+']').show();

    //
    newsId = this.app.prodId;
    if(newsId !== ""){
      this.showDetail();
    }
  }
}
